import React from 'react';
import InputWithLabel from './InputWithLabel';
import { Form, Field } from 'react-final-form';
import Validator from '../helpers/contactDetailValidator';
import localization from '../helpers/localization.js';
import { countries } from '../helpers/localization.js';
import { contentRoot } from '../config.js';
import SaunaImageContainer from '../containers/SaunaImageContainer';

const ContactDetailsComponent = ({ prevPage, submitContactForm, showResellerAssistanceRequest, resellerAssistanceChanged, resellerAssistanceRequested,planType }) => {
    const contactDetailValidator = new Validator();
    return (<div className="page">
        <SaunaImageContainer />
        <picture>
            <source srcSet={contentRoot + "img/letter.webp"} type="image/webp" />
            <img src={contentRoot + "img/letter.png"} alt="letter" className="letter" />
        </picture>
        <h1>{getPlanTypeDescription(planType)}</h1>
        <p>{localization.giveContactDetails}</p>
        <Form validate={values => { return contactDetailValidator.validate(values);}}
            onSubmit={submitContactForm}
            render={({ handleSubmit, form, submitting, pristine, values }) => (
                <form onSubmit={handleSubmit} id="contactDetailForm">
                    <InputWithLabel label={localization.name} name="name" type="text" placeHolder={localization.namePlaceHolder} />
                    <InputWithLabel label={localization.city} name="city" type="text" placeHolder={localization.cityPlaceHolder} />
                    <InputWithLabel label={localization.postalNumber} name="postalNumber" type="text" placeholder={localization.postalNumberPlaceHolder} />
                    <InputWithLabel label={localization.address} name="address" type="text" placeHolder={localization.addressPlaceHolder} />
                    <InputWithLabel label={localization.phone} name="phone" type="text" placeHolder={localization.phonePlaceHolder} />
                    <InputWithLabel label={localization.email} name="email" type="email" placeHolder={localization.emailPlaceHolder} />
                    <div className="inputWithLabel">
                        <label htmlFor="country" className="textinputLabel">{localization.country} </label>
                        <Field name="country" component="select">
                            {buildOptions()}
                        </Field>
                    </div>
                    <InputWithLabel label={localization.attachment} name="attachments" type="file" multiple />
                    <div className="inputWithLabel">
                        <label htmlFor="notes" className="textinputLabel">{localization.notes} {planType == "onlyContactDetails" ? localization.quickOfferDescription:""}</label>
                        <Field name="notes" component="textarea" placeholder={localization.projectExtraInfo}/>
                    </div>
                    {resellerAssistanceRequestLabel(showResellerAssistanceRequest, resellerAssistanceChanged, resellerAssistanceRequested)}
                    <InputWithLabel label={localization.consent} name="consent" infoLink="https://sunsauna.fi/rekisteriseloste/" type="checkbox" />    
                    <div className="changePhaseRow">
                        <span className="orangeButton changePhaseButton" onClick={() => { prevPage() }}> <span className="buttonTxt">&#8592;  {localization.prevPhase}</span></span>
                        <button className="orangeButton changePhaseButton" type="submit">
                            <span className="buttonTxt">{localization.sendOfferRequest}</span>
                        </button>
                    </div>
                </form>)
            }
        />



    </div>);
};
export default ContactDetailsComponent



const buildOptions = () => {
    return Object.entries(countries.countryNames).map(option => (<option value={option[0]} key={option[0]} >{option[1]}</option>))
}


const resellerAssistanceRequestLabel = (show, resellerAssistanceChanged, resellerAssistanceRequested) => {
    if (show) {
        return(<div>
            <label htmlFor="requestResellerAssistance" className="textinputLabel">{localization.askResellerAssistance} </label>
            <input type="checkbox" value={resellerAssistanceRequested} name="requestResellerAssistance" onChange={(event) => resellerAssistanceChanged(event.target.checked)} />      
        </div>);  
    }
    else
        return ""

}
const getPlanTypeDescription = (planType) => {
    if (planType == "onlyContactDetails")
        return localization.leaveQuickOffer;
    else
        return localization.downloadPlan;
}
